import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white p-6 shadow-md rounded-md">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">
          Privacy Policy
        </h1>

        <p className="text-gray-700 mb-4">
          At Smart Nexus Solutions, we respect the privacy of our users and the
          importance of the information they entrust to us.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 mb-3">
          Nature of Information Collected
        </h2>
        <p className="text-gray-700 mb-2">
          We may collect information that can identify you (“personal
          information”), such as your name, email address, preferences, or phone
          numbers, especially if you are the owner of a brand or business. This
          information is provided when you use our website or interact with us
          in other ways.
        </p>
        <p className="text-gray-700 mb-2">
          We may also collect “Non-Personal Information”—information that cannot
          be used to identify you—via Cookies, even if you have not registered
          with or provided any Personal Information to Smart Nexus Solutions.
        </p>

        <h3 className="text-lg font-semibold text-gray-800 mb-2">
          Additionally, we may collect information in the following ways:
        </h3>
        <ul className="list-disc list-inside text-gray-700 mb-4">
          <li>
            <strong>Server Logs:</strong> Automatically collect information such
            as your IP address, browser type and language, and the date and time
            of your visit, helping us track user movements and understand
            trends.
          </li>
          <li>
            <strong>Cookies:</strong> Assign your computer one or more cookies
            to collect information and facilitate website access, personalizing
            your online experience.
          </li>
          <li>
            <strong>Third-Party Advertisers:</strong> We may allow third-party
            advertising companies or ad networks to display ads on our website.
            While we do not provide personal information to these companies,
            they may use tracking tools like cookies to collect information
            about computers interacting with their advertisements.
          </li>
          <li>
            <strong>User Posts:</strong> If you post or communicate on our
            website, we cannot control who reads your postings or how they use
            the information. We encourage caution when sharing personal
            information.
          </li>
        </ul>

        <h2 className="text-xl font-semibold text-gray-800 mb-3">
          Usage of Information
        </h2>
        <ul className="list-disc list-inside text-gray-700 mb-4">
          <li>Fulfill your requests for products and services.</li>
          <li>Offer products and services that may interest you.</li>
          <li>Facilitate use of our website.</li>
          <li>Manage your account and preferences.</li>
          <li>
            Analyze usage and improve our website, products, and services.
          </li>
          <li>
            Identify and protect against fraudulent transactions or misuse of
            our website.
          </li>
          <li>Enforce our Terms of Use.</li>
        </ul>

        <h2 className="text-xl font-semibold text-gray-800 mb-3">
          Do We Share Information?
        </h2>
        <p className="text-gray-700 mb-4">
          We will not share your personal information except as indicated below
          or when you are informed in advance and given the opportunity to opt
          out.
        </p>
        <ul className="list-disc list-inside text-gray-700 mb-4">
          <li>
            <strong>Service Providers:</strong> We may share personal
            information with service providers (e.g., payment processors)
            performing services on our behalf.
          </li>
          <li>
            <strong>Aggregated Data:</strong> We may share non-personal,
            aggregated statistics with advertisers and others.
          </li>
        </ul>

        <h2 className="text-xl font-semibold text-gray-800 mb-3">
          How to Delete/Request Deletion of Your Data?
        </h2>
        <p className="text-gray-700 mb-4">
          If you’ve granted access to your information via a connector or
          integration, you can delete that particular information by removing
          the connector/integration. To delete all your organization’s data,
          please send an email to{" "}
          <a
            href="mailto:saurabh@smartnexussolutions.com"
            className="text-blue-500 underline"
          >
            saurabh@smartnexussolutions.com
          </a>
          .
        </p>

        <h2 className="text-xl font-semibold text-gray-800 mb-3">
          What Choices Do I Have?
        </h2>
        <p className="text-gray-700 mb-4">
          Most browsers can be set to reject cookies. Additionally, you can opt
          out of cookies for several ad servers by visiting the Network
          Advertising Initiative gateway opt-out site.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 mb-3">Security</h2>
        <p className="text-gray-700 mb-4">
          We implement physical, electronic, and other security measures to
          safeguard personal information from unauthorized access, alteration,
          or disclosure.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 mb-3">
          Changes to Our Privacy Policy
        </h2>
        <p className="text-gray-700 mb-4">
          We may occasionally update our Privacy Policy to reflect changes in
          our practices and services.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 mb-3">Contact Us</h2>
        <p className="text-gray-700">
          If you have any questions about this summary, our Privacy Policy, or
          our information practices, please email us at{" "}
          <a href="mailto:email.com" className="text-blue-500 underline">
            saurabh@smartnexussolutions.com
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
